import React from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';

import { changeLanguage } from '../actions/intl';

const messages = defineMessages({
  SWITCH_LOCALE: {
    id: 'SelectLanguageButton.SWITCH_LOCALE',
    defaultMessage: 'Sprache wechseln',
  },
  SWITCH_TO_DE: {
    id: 'SelectLanguageButton.SWITCH_TO_DE',
    defaultMessage: 'Zu Deutsch wechseln',
  },
  SWITCH_TO_EN: {
    id: 'SelectLanguageButton.SWITCH_TO_EN',
    defaultMessage: 'Zu Englisch wechseln',
  },
  SWITCH_TO_FR: {
    id: 'SelectLanguageButton.SWITCH_TO_FR',
    defaultMessage: 'Zu Französisch wechseln',
  },
  SWITCH_TO_ES: {
    id: 'SelectLanguageButton.SWITCH_TO_ES',
    defaultMessage: 'Zu Spanisch wechseln',
  },
});

function SelectLanguageButton(props) {
  const { locale, textVersion = false, company, intl: { formatMessage } } = props;
  
  // Default languages
  let allowedLanguages = ['de', 'en'];
  if (company && company.allowed_languages) {
    allowedLanguages = company.allowed_languages.split(',').map(l => l.trim().toLowerCase()).filter(l => l);
  }
  if (allowedLanguages.length === 0) allowedLanguages = ['de', 'en'];

  // Find next language
  const currentIndex = allowedLanguages.indexOf(locale);
  let nextLocale = 'en';
  if (currentIndex >= 0 && currentIndex < allowedLanguages.length - 1) {
    nextLocale = allowedLanguages[currentIndex + 1];
  } else if (allowedLanguages.length > 0) {
    nextLocale = allowedLanguages[0];
  }

  const updateLocale = () => props.changeLanguage(nextLocale);

  const tooltipKey = `SWITCH_TO_${nextLocale.toUpperCase()}`;
  const title = messages[tooltipKey] ? formatMessage(messages[tooltipKey]) : formatMessage(messages.SWITCH_LOCALE);

  if (textVersion) {
    return (
      <a onClick={updateLocale} style={{ cursor: 'pointer' }} title={title}>
        Switch to {nextLocale}
      </a>
    );
  }

  return (
    <button
      onClick={updateLocale}
      className="lh-btn lh-btn-small lh-btn-default"
      title={title}
      style={{ height: '34px', boxSizing: 'border-box' }}
    >
      {nextLocale.toUpperCase()}
    </button>
  );
}

export default connect(
  state => ({ 
    locale: state.intl.locale,
    company: state.navbar && state.navbar.company
  }),
  { changeLanguage },
)(injectIntl(SelectLanguageButton));
